module.exports = __webpack_public_path__ + "static/media/notification_icon_failure.e2379c3f.svg";